/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Manage_BookingsInputs */

const en_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Bookings`)
};

const de_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungen verwalten`)
};

const es_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar reservas`)
};

const fr_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les réservations`)
};

const nl_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveringen beheren`)
};

const it_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci prenotazioni`)
};

const pt_br2_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar reservas`)
};

const pl_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj rezerwacjami`)
};

const hu_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalások kezelése`)
};

const ro_admin_dashboard_manage_bookings = /** @type {(inputs: Admin_Dashboard_Manage_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionati Rezervarile`)
};

/**
* | output |
* | --- |
* | "Manage Bookings" |
*
* @param {Admin_Dashboard_Manage_BookingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_manage_bookings = /** @type {((inputs?: Admin_Dashboard_Manage_BookingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Manage_BookingsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_manage_bookings(inputs)
	if (locale === "de") return de_admin_dashboard_manage_bookings(inputs)
	if (locale === "es") return es_admin_dashboard_manage_bookings(inputs)
	if (locale === "fr") return fr_admin_dashboard_manage_bookings(inputs)
	if (locale === "nl") return nl_admin_dashboard_manage_bookings(inputs)
	if (locale === "it") return it_admin_dashboard_manage_bookings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_manage_bookings(inputs)
	if (locale === "pl") return pl_admin_dashboard_manage_bookings(inputs)
	if (locale === "hu") return hu_admin_dashboard_manage_bookings(inputs)
	return ro_admin_dashboard_manage_bookings(inputs)
});
export { admin_dashboard_manage_bookings as "admin.dashboard.manage_bookings" }